import type { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { Heading } from '@shieldpay/bumblebee/heading';
import { Column } from '@shieldpay/bumblebee/layout';

import { CONTENT_IDS } from '../contents-table/utils';

export interface DesignProps {
  children: ReactNode;
}

export interface DesignSectionProps {
  heading: ReactNode;
  children: ReactNode;
}

export const Design = ({ children }: DesignProps) => {
  return (
    <Column spacing="base">
      <Heading level="2" id={CONTENT_IDS.DESIGN}>
        <FormattedMessage id="hive.titles.design" />
      </Heading>
      {children}
    </Column>
  );
};

const DesignSection = ({ children, heading }: DesignSectionProps) => (
  <Column spacing="base">
    <Heading level="3" variant="title">
      {heading}
    </Heading>
    <Column spacing="base">{children}</Column>
  </Column>
);

Design.Section = DesignSection;
